import { format, parse, isValid } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

// value is ISO yyyy-MM-dd (or ""), displayed as MM/dd/yyyy
export function DatePicker({ value, onChange, placeholder = "mm/dd/yyyy", testid, className, disabled }) {
  const date = value ? parse(value, "yyyy-MM-dd", new Date()) : null;
  const valid = date && isValid(date);
  return (
    <Popover modal>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" disabled={disabled} data-testid={testid}
          className={cn("w-full justify-start text-left font-normal font-mono-num h-10", !valid && "text-muted-foreground", className)}>
          <CalendarIcon className="mr-2 h-4 w-4 shrink-0" />
          {valid ? format(date, "MM/dd/yyyy") : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[200]" align="start" onOpenAutoFocus={(e) => e.preventDefault()}>
        <div className="p-2 border-b border-border">
          <input type="date" aria-label="Type a date" data-testid={testid ? `${testid}-input` : undefined} value={valid ? format(date, "yyyy-MM-dd") : ""} onChange={(e) => onChange(e.target.value)} className="w-full h-8 rounded-md border border-input bg-background px-2 text-sm font-mono-num" />
        </div>
        <Calendar mode="single" selected={valid ? date : undefined} defaultMonth={valid ? date : undefined}
          onSelect={(d) => onChange(d ? format(d, "yyyy-MM-dd") : "")} />
      </PopoverContent>
    </Popover>
  );
}

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = parse(String(iso).slice(0, 10), "yyyy-MM-dd", new Date());
  return isValid(d) ? format(d, "MM/dd/yyyy") : iso;
};

export const fmtDateTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return isValid(d) ? format(d, "MM/dd/yyyy h:mm a") : iso;
};
